module.exports = __webpack_public_path__ + "static/media/table.5ff0497c.svg";